import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import store from 'src/services/redux/app/Store';
import { IInventory, IInventoryListResponse } from '../../../../interfaces';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;

interface IState {
  data: IInventory[];
  totalCount: number;
  itemCount: number;
  pageCount: number;
  currentPage: number;
  limit: number;
  loading: boolean;
  done: boolean;
  showError: boolean;
  error: any;
}

interface IRequestParams {
  brandId?: string;
  categoryId?: string;
  productPriceLockReasonId?: string;
  title?: string;
  stockCode?: string;
  barcode?: string;
  search?: string;
  state?: string;
  nonSale?: boolean;
  page: number;
  limit: number;
}

const initialState: IState = {
  data: [],
  totalCount: 0,
  itemCount: 0,
  pageCount: 0,
  currentPage: 0,
  limit: 0,
  loading: false,
  done: false,
  error: null,
  showError: false,
};

export const inventoryList = createAsyncThunk('inventory/list', async (params: IRequestParams = { page: 1, limit: 10 }) => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get<IInventoryListResponse>(`${VENDOR_MC_URL}/vendor/${userId}/inventory/list`, { params });
  return res.data;
});

export const inventoryUpdate = createAsyncThunk('inventory/update', async (data: any) => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get<IInventory>(`${VENDOR_MC_URL}/vendor/${userId}/inventory/update`, data);
  return res.data;
});

const inventoryListSlice = createSlice({
  name: 'productReviews',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.showError = action.payload;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(inventoryList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(inventoryList.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload.items;
      state.totalCount = action.payload.totalCount;
      state.currentPage = action.payload.currentPage;
      state.itemCount = action.payload.itemCount;
      state.limit = action.payload.limit;
      state.pageCount = action.payload.pageCount;
      state.done = true;
    });
    builder.addCase(inventoryList.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Veri listelenemedi.';
      state.data = [];
    });
    //
    builder.addCase(inventoryUpdate.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(inventoryUpdate.fulfilled, (state, action) => {
      const index: number = state.data?.findIndex((item) => item.id === action.payload?.id);
      state.data[index] = action.payload;
      state.loading = false;
      state.done = true;
    });
    builder.addCase(inventoryUpdate.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Veri listelenemedi.';
      state.data = [];
    });
  },
});
export const { setError } = inventoryListSlice.actions;
export default inventoryListSlice.reducer;
